export default "__VITE_ASSET__03f51e5f__"